import React, { useState, useEffect } from 'react';

import Api from 'utils/api';

import styles from './MachineTemplateTab.module.css';

const MachineTemplateTab = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);

  // 모달 및 폼 상태
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({ machineTemplateId: null, machineTemplateName: '' });

  useEffect(() => {
    fetchTemplateList();
  }, []);

  // 1. 리스트 조회 (GET)
  const fetchTemplateList = async () => {

    setLoading(true);
    const data = await Api.get('/machine/template');
    setTemplates(data.machineTemplateList || []);
    setLoading(false);

  };

  const handleOpenModal = (mode, data = null) => {
    setIsEditMode(mode === 'edit');
    setFormData(data ? { ...data } : { machineTemplateId: null, machineTemplateName: '' });
    setIsModalOpen(true);
  };

  // 2. 저장 로직 (POST)
  const handleSave = async () => {
    if (!formData.machineTemplateName.trim()) {
      return alert("템플릿 이름을 입력해주세요.");
    }

    try {
      let response;

      if (isEditMode) {
        const requestBody = {
          machineTemplateId: formData.machineTemplateId,
          machineTemplateName: formData.machineTemplateName
        };

        response = await Api.patch('/machine/template', requestBody);
      } else {
        const requestBody = {
          machineTemplateName: formData.machineTemplateName
        };

        response = await Api.post('/machine/template', requestBody);
      }

      if (!response) return;

      alert(isEditMode ? "수정이 완료되었습니다." : "등록이 완료되었습니다.");
      setIsModalOpen(false);
      fetchTemplateList();

    } catch (error) {
      console.error("통신 오류:", error);
      alert("서버와 통신 중 오류가 발생했습니다.");
    }

  };

  // 3. 삭제 로직 (DELETE)
  const handleDelete = async (id) => {
    if (!window.confirm("이 템플릿를 삭제하시겠습니까?")) return;

    const data = await Api.delete(`/machine/template?machineTemplateId=${id}`)

    if (data.code === 200) {
      alert("삭제가 완료되었습니다.");
      fetchTemplateList(); // 삭제 후 목록 최신화
    } else {
      alert(`삭제 실패: ${data.message || '오류가 발생했습니다.'}`);
    }

  };

  if (loading) return <div className={styles.centerMsg}>템플릿 정보를 불러오는 중...</div>;

  return (
    <div className={styles.container}>
      <div className={styles.topBar}>
        <div className={styles.countInfo}>등록된 템플릿 <span className={styles.countNumber}>{templates.length}</span></div>
        <button className={styles.addBtn} onClick={() => handleOpenModal('add')}>+ 템플릿 등록</button>
      </div>

      <div className={styles.cardGrid}>
        {templates.map((f) => (
          <div key={f.machineTemplateId} className={styles.templateCard}>
            <div className={styles.cardHeader}>
              <div>
                <h3 className={styles.templateName}>{f.machineTemplateName}</h3>
              </div>
            </div>

            <div className={styles.cardFooter}>
              <button className={styles.editBtn} onClick={() => handleOpenModal('edit', f)}>수정</button>
              <button className={styles.deleteBtn} onClick={() => handleDelete(f.machineTemplateId)}>삭제</button>
            </div>
          </div>
        ))}
      </div>

      {isModalOpen && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <div className={styles.modalHeader}>
              <h3>{isEditMode ? '템플릿 수정' : '새 템플릿 등록'}</h3>
              <button className={styles.closeBtn} onClick={() => setIsModalOpen(false)}>✕</button>
            </div>
            <div className={styles.modalBody}>
              <div className={styles.formContainer}>
                <div className={styles.inputGroup}>
                  <label>템플릿 명칭</label>
                  <input
                    name="machineTemplateName"
                    value={formData.machineTemplateName}
                    onChange={(e) => setFormData({ ...formData, machineTemplateName: e.target.value })}
                    className={styles.modalInput}
                    autoFocus
                  />
                </div>
              </div>
            </div>
            <div className={styles.modalFooter}>
              <button className={styles.cancelBtn} onClick={() => setIsModalOpen(false)}>취소</button>
              <button className={styles.saveBtn} onClick={handleSave}>저장하기</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MachineTemplateTab;